import { BefGlobalContext, BefPageServiceContext } from "@beflam/bef-core";
import { useContext, useEffect, useReducer, useState } from "react";
import ReactRenderer from '../renderer/factory';
import { LibraryManager } from "../assets/library-manager";
// import allcomponents from "./allcomponents";
// import fusionPackages from './fusion-package'

export function BefQueryContainer(props: any) {
    const sGlobal = useContext(BefGlobalContext);
    const pageService = useContext(BefPageServiceContext);

    const [zIndex, setZIndex] = useState(100);
    const [queryPageWidth, setQueryPageWidth] = useState("40%");

    const mLeftReducer = (state: string, action: any) => {
        if (action.zIndex > 0) {
            return "calc(" + action.queryPageWidth + " + 20px)";
        } else {
            return "0px";
        }
    }
    const [mLeft, setMLeft] = useReducer(mLeftReducer, "calc(" + queryPageWidth + " + 20px)");

    const [renderData, setRenderData] = useState<any>(null);
    const getRenderData = async () => {
        // let ComponentMap: Record<string, any> = (window as any)['ComponentMap'];
        // if (!ComponentMap) {
        //     ComponentMap = await loadComponentsAsync(allcomponents, fusionPackages.packages);
        //     (window as any)['ComponentMap'] = ComponentMap;
        // }
        const ComponentMap = LibraryManager.components;
        let i18n = {
            "zh-CN": {},
            "en-US": {}
        };
        let pageSchema = {
            id: "node_page",
            componentName: "Page",
            props: {
                ref: "outerView",
                style: {
                    height: "100%"
                }
            },
            children: [{
                id: "node_query",
                componentName: "BefQuery",
                props: {
                    anaID: pageService.page.anaId,
                    isCollapse: pageService.page.isCollapse
                },
                children: [],
                isLocked: false,
                title: "",
                ignore: false,
                hidden: false,
                condition: true,
                conditionGroup: "",
                defaultProps: null
            }],
            isLocked: false,
            title: "",
            ignore: false,
            hidden: false,
            condition: true,
            conditionGroup: "",
            defaultProps: null
        };
        setRenderData({ pageSchema, ComponentMap, i18n, dataSourceData: [] });
    }

    useEffect(() => {
        const onQuerySub = pageService.onQuery.subscribe((data) => {
            setZIndex(-1000);
            setMLeft({ zIndex: -1000 });
        });
        if (pageService.page.isDialog) {
            setQueryPageWidth("90%");
            setMLeft({ zIndex: 1000, queryPageWidth: "90%" });
        }
        else if (pageService.page.queryWidth) {
            setQueryPageWidth(pageService.page.queryWidth);
            setMLeft({ zIndex: 1000, queryPageWidth: pageService.page.queryWidth });
        }
        else if (sGlobal.beflamFrameworkClientConfig.QueryWidth) {
            setQueryPageWidth(sGlobal.beflamFrameworkClientConfig.QueryWidth);
            setMLeft({ zIndex: 1000, queryPageWidth: sGlobal.beflamFrameworkClientConfig.QueryWidth });
        }

        getRenderData();

        return () => {
            onQuerySub.unsubscribe();
        };
    }, []);

    const push = () => {
        if (zIndex > 0) {
            setZIndex(-1000);
            setMLeft({ zIndex: -1000 });
        }
        else {
            setZIndex(1000);
            setMLeft({ zIndex: 1000, queryPageWidth: queryPageWidth });
        }
    }
    return (
        <>
            <div className="gray-bg" style={{ width: "100%", height: "100%", position: "absolute", opacity: 1, zIndex: zIndex - 1 }}></div>
            <div className="bef-pagequery" style={{ width: queryPageWidth, height: "96%", zIndex: zIndex, position: "absolute", backgroundColor: "white", border: "1px", padding: "6px 5px 20px 5px", margin: "20px 20px 10px 20px" }}>
                {renderData && <ReactRenderer
                    schema={renderData.pageSchema as any}
                    components={renderData.ComponentMap}
                    eventHandlers={pageService.context}
                    dataSourceData={renderData.dataSourceData}
                    messages={renderData.i18n}
                    state={pageService.context}
                    locale={sGlobal?.session?.lang}
                />}
            </div>
            <div style={{ position: "absolute", zIndex: 1000, marginTop: "20%", marginLeft: mLeft }}>
                <a onClick={push}><img className="bef-btn-query-ico" style={{ backgroundColor: "transparent", width: "40px" }} alt="search" src="./assets/img/search.png" /></a>
            </div>
        </>
    );
}